module.exports = __webpack_public_path__ + "static/media/marcas.5135596c.png";